import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { formatPrice } from '../../utils/formatPrice';

interface ConfirmCreateDialogProps {
  open: boolean;
  documentsCount: number;
  itemsCount: number;
  total: number;
  issueDate: Date;
  onIssueDateChange: (date: Date) => void;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmCreateDialog = ({
  open,
  documentsCount,
  itemsCount,
  total,
  issueDate,
  onIssueDateChange,
  isLoading,
  onClose,
  onConfirm
}: ConfirmCreateDialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Vystavit výdajový doklad</DialogTitle>
    <DialogContent>
      <Stack gap={2} pt={1}>
        <DialogContentText>
          Vybráno POJ: {itemsCount}. Odhad počtu dokladů: {documentsCount}. Celková částka: {formatPrice(total, 2)}.
        </DialogContentText>
        <DialogContentText variant="body2">
          Vzniká jeden doklad na tipaře, nejvýše 5 POJ na doklad. Při platbě v hotovosti je navíc strop 10 000 Kč na
          doklad. Skutečný počet určí systém, POJ nad hotovostní limit se mohou vrátit jako nevyplacené.
        </DialogContentText>
        <DatePicker
          label="Datum vystavení"
          format="dd.MM.yyyy"
          value={issueDate}
          onChange={(date) => date && onIssueDateChange(date)}
        />
      </Stack>
    </DialogContent>
    <DialogActions sx={{ p: 3, justifyContent: 'center', gap: 2 }}>
      <Button onClick={onClose}>Zavřít</Button>
      <Button variant="contained" onClick={onConfirm} loading={isLoading}>
        Vystavit
      </Button>
    </DialogActions>
  </Dialog>
);
